export const AllUnits: Record<string, string> = {
  // weight
  gram: 'گرم',
  grams: 'گرم',
  kilogram: 'کیلوگرم',
  kilograms: 'کیلوگرم',
  kg: 'کیلوگرم',
  ton: 'تن',

  // volume
  liter: 'لیتر',
  liters: 'لیتر',
  litre: 'لیتر',
  litres: 'لیتر',
  l: 'لیتر',
  milliliter: 'میلی لیتر',
  ml: 'میلی لیتر',
  cubicmeter: 'مترمکعب',
  cubic_meter: 'مترمکعب',
  m3: 'مترمکعب',

  // counting
  number: 'عدد',
  piece: 'قطعه',
  pieces: 'قطعه',
  box: 'جعبه',
  pack: 'بسته',
  unit: 'واحد',
  head: 'راس',
  device: 'دستگاه',
  trunk: 'اصله',
  meter: 'متر',
  // area
  hectare: 'هکتار',
  squaremeter: 'مترمربع',
  square_meter: 'مترمربع',

  // time
  hour: 'ساعت',
  day: 'روز',
  month: 'ماه',
  year: 'سال',
  second: 'ثانیه',

  // rates
  hourly: 'ساعتی',
  daily: 'روزانه',
  monthly: 'ماهانه',
  yearly: 'سالانه',
  per_hour: 'در ساعت',
  per_day: 'در روز',
  per_second: 'در ثانیه',
  per_hectare: 'در هکتار',

  // special
  unitless: 'بدون واحد',
};

export const convertEnglishUnitToFa = (input: string): string => {
  if (!input) return 'بدون واحد';

  const normalized = input
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');

  return AllUnits[normalized] || 'بدون واحد';
};
